/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type GetScheduleParams = {
from: string;
to: string;
/**
 * @minimum 1
 * @maximum 500
 */
limit?: number;
};
